!function() {
  const observer = new MutationObserver(records => {
    records.flatMap(record => [...record.addedNodes]).forEach(watcher);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window._customlazyload = window._customlazyload || {
    observer,
    loaded: false
  };

  function watcher(node) {

    const { nodeType, tagName, src } = node;

    if (nodeType === 1 && tagName === "IFRAME") {
      // if (src.includes("youtube.com") || src.includes("vimeo.com")) {
      //   node.setAttribute("loading", "lazy");
      //   node.setAttribute("data-src", src);
      //   node.removeAttribute("src");
      // }
    } 

    if (nodeType === 1 && tagName === "LINK") {
      if (node.href.includes("place") || node.href.includes("vimo.com")) {
        node.setAttribute("data-href", node.href);
        node.removeAttribute("href");
      }
    }

    if (nodeType === 1 && tagName === "IMG" && !src.includes("data:image") && !node.classList.contains('lazyload')) {
      node.setAttribute("loading", "lazy");
    }

    if (nodeType === 1 && tagName === "SCRIPT") {
      if (
        node.className === "analytics" ||
        node.className === "boomerang"
      ) {
        node.type = "text/lazyload";
      }

      if (node.innerHTML.includes("asyncLoad")) {
        node.innerHTML = 
          node.innerHTML
            .replace(
              "if(window.attachEvent)",
              "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)"
            )
            .replaceAll(
              ", asyncLoad",
              ", function(){}"
            );
      }

      if (
        node.innerHTML.includes("PreviewBarInector") || 
        node.innerHTML.includes("adminBarInjector")
      ) {
        node.innerHTML = node.innerHTML.replace("DOMContentLoaded", "asyncLazyLoad");
      }

      if (
        src.includes("assets/stoefront") || 
        src.includes("assets/shopify_pay") || 
        src.includes("gdpr_cookie") || 
        src.includes("checker.js")
      ) {
        node.setAttribute("data-src", node.src);
        node.removeAttribute("src");
      }

      if (
        node.innerText.includes("tracker") || 
        node.innerText.includes("webPixelsManager") || 
        node.innerText.includes("fera") || 
        node.innerText.includes("gtm.start")
      ) {
        node.type = "text/lazyload";
      }
    }
  }
}();
